module.exports = __webpack_public_path__ + "static/media/DOC.e3c5851f.svg";